<template>
  <el-row class="infogr-bid">
    <p class="bid-id">Перевозка №{{ bid.id }}</p>
    <el-card>
      <el-row class="promo_right">
        <span class="weight">Всего: {{ bid.weight }} т</span>
      </el-row>
      <el-row>
        <el-col :span="15" class="promo-col">
          <el-row type="flex" align="middle">
            <div>
              <h2 class="d_h2">{{ loadLocationFilter(bid) }}</h2>
              <p class="ri_p1">{{ bid.load_point.split(',')[0] }}</p>
            </div>
            <div class="sh_dist">
              <img src="@/assets/img/arrow-route.svg" />
              <p class="ri_p2">{{ bid.distance }} км</p>
            </div>
            <div>
              <h2 class="d_h2">{{ findStevedore(bid) }}</h2>
              <p class="ri_p1">{{ bid.unload_point.split(',')[1] }}</p>
            </div>
          </el-row>
          <el-row class="last-row">
            Тралы {{ bid.is_trawl ? '' : 'не ' }}грузят,
            {{ bidsTypes[bid.load_type_id] ? bidsTypes[bid.load_type_id] : '' }}
          </el-row>
        </el-col>
        <el-col :span="6">
          <days-info :days="days" />
        </el-col>
        <el-col :span="3">
          <h2 class="distance">
            <img src="@/assets/img/grass.svg" />
            {{ freightsTypes[bid.freight_id] }}
          </h2>
        </el-col>
      </el-row>
    </el-card>
  </el-row>
</template>

<script>
import DaysInfo from './DaysInfo'
import shippingMixin from '@/mixins/shippingMixin'

export default {
  name: 'ThirdFrame',
  components: { DaysInfo },
  mixins: [shippingMixin],
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    freightsTypes: {
      type: Object,
      default: () => {},
    },
    bidsTypes: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    days() {
      const { 'load-days': lds } = this.bid
      const days = lds ? lds.slice(0, 2) : []

      return days.reduce((d, x) => {
        const {
          price_ordered,
          price_not_subscribed,
          price_subscribed,
          load_date,
        } = x

        if (d[price_ordered]) {
          d[price_ordered].dates.push(load_date)
        } else {
          d[price_ordered] = {
            prices: { price_subscribed, price_not_subscribed },
            dates: [load_date],
          }
        }

        return d
      }, {})
    },
  },
}
</script>

<style lang="sass">
.infogr-bid
  .bid-id
    color: #9D9D9D;
    font-weight: bold;
    font-size: 20px;
  .el-card
    padding: 30px 40px;
    font-family: Rubik, sans-serif;
    color: #000;
    margin-bottom: 60px;
    .promo_right
      text-align: right
      .weight
        font-size: 22px
        line-height: 17px
        color: rgba(0, 0, 0, 0.7)
        border-radius: 5px
    .el-card__body
      padding: 0;
    .promo-col
      p
        font-size: 20px
        line-height: 17px
        margin: 20px 0 0;
        &.ri_p1
          color: rgba(0, 0, 0, 0.5)
        &.ri_p2
          color: #000000
      .d_h2
         margin: 0
         font-size: 50px
      .sh_dist
        display: flex
        flex-direction: column
        margin: 0 25px
        align-items: center
        img
          width: 80px;
          margin-top: 27px;
    .distance
      font-size: 36px
      display: flex
      justify-content: flex-end
      margin: 35px 0 0;
      img
        margin-right: 20px;
        width: 20px;
    .last-row
      font-size: 28px;
      margin-top: 40px;
</style>
